import { render, staticRenderFns } from "./SidebarDropdown.vue?vue&type=template&id=b3145a20&scoped=true&"
import script from "./SidebarDropdown.vue?vue&type=script&lang=js&"
export * from "./SidebarDropdown.vue?vue&type=script&lang=js&"
import style0 from "./SidebarDropdown.vue?vue&type=style&index=0&id=b3145a20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3145a20",
  null
  
)

export default component.exports